export default __webpack_public_path__ + "static/media/Nesha_Laser_0000_Particle_1.2b376697.png";